import { CurrencyPipe, DatePipe, JsonPipe, NgFor } from '@angular/common';

import { compileDeclareNgModuleFromMetadata } from '@angular/compiler';
import { Component, Input } from '@angular/core';
import { IMiPrelimHeader } from 'src/app/shared/interfaces';

@Component({
  selector: 'app-mi-invoice-header',
  standalone: true,
  imports: [NgFor, DatePipe, CurrencyPipe],
  templateUrl: './mi-invoice-header.component.html',
  styleUrl: './mi-invoice-header.component.scss',
})
export class MiInvoiceHeaderComponent {
  @Input() set miHeaderdetail(value: IMiPrelimHeader) {
    this.invoiceHeaderForDisplay = value;
    this.formatLotAddressData();
    this.formatCustomerData();
  }
  invoiceHeaderForDisplay: IMiPrelimHeader;
  lotAddressHeaderArray: string[] = [];
  customerAddressHeaderArray: string[] = [];
  constructor() {}

  formatLotAddressData(): void {
    let header: string[] = [];
    let d: IMiPrelimHeader = this.invoiceHeaderForDisplay; // temporarily assign to d for readability

    header.push(d.lotName);
    d.lotAddress1.length > 0 ? header.push(d.lotAddress1) : '';

    if (d.lotAddress2.length > 0) {
      if (d.lotAddress1.length > 0) {
        header[header.length - 1] += ', ';
      }
      header[header.length - 1] += d.lotAddress2;
    }

    if (d.lotCity.length > 0 || d.lotState.length > 0 || d.lotZip.length > 0) {
      var citystatezipline: string = d.lotCity.length > 0 ? d.lotCity + ' ' : '';

      d.lotState.length > 0 ? (citystatezipline += d.lotState + ' ') : '';
      d.lotZip.length > 0 ? (citystatezipline += d.lotZip) : '';
      citystatezipline.length > 0 ? header.push(citystatezipline) : '';
    }

    d.lotPhoneNumber.length > 0 ? header.push(d.lotPhoneNumber) : '';
    d.lotEmailAddress.length > 0 ? header.push(d.lotEmailAddress) : '';

    this.lotAddressHeaderArray = header;
  }

  formatCustomerData(): void {
    let header: string[] = [];
    let d: IMiPrelimHeader = this.invoiceHeaderForDisplay; // temporarily assign to d for readability

    d.customerAddress1.length > 0 ? header.push(d.customerAddress1) : '';

    if (d.customerAddress2.length > 0) {
      if (d.customerAddress1.length > 0) {
        header[header.length - 1] += ', ';
      }
      header[header.length - 1] += d.customerAddress2;
    }

    if (d.customerCity.length > 0 || d.customerState.length > 0 || d.customerZip.length > 0) {
      var citystatezipline: string = d.customerCity.length > 0 ? d.customerCity + ' ' : '';

      d.customerState.length > 0 ? (citystatezipline += d.customerState + ' ') : '';
      d.customerZip.length > 0 ? (citystatezipline += d.customerZip) : '';
      citystatezipline.length > 0 ? header.push(citystatezipline) : '';
    }

    d.customerPhoneNumber.length > 0 ? header.push(d.customerPhoneNumber) : '';
    d.customerEmailAddress.length > 0 ? header.push(d.customerEmailAddress) : '';
    d.customerAttentionContactName.length > 0 ? header.push('Attn: ' + d.customerAttentionContactName) : '';

    this.customerAddressHeaderArray = header;
  }
}
